import { Deserializable } from './deserializable';

export class MorphModel implements Deserializable {

  // columns
  id: number;
  type: string;

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }

}
